import React, { useState } from 'react';
import {
  Box,
  ButtonBase,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonTableDialog from 'components/commonTableDialog/CommonTableDialog';
import { businessTypeData } from 'utils/enumObj';
import profilePic from 'assets/images/SubVendorLogo.svg';
import location from 'assets/images/smLocationIcon.svg';
import star from 'assets/images/smStar.svg';
import editmore from 'assets/images/moreEditIcon.svg';
import deleteicon from 'assets/images/delete.svg';
import deactive from 'assets/images/deActivate.svg';
import block from 'assets/images/block.svg';

function DetailsCard(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const details = props.details;

  const handleOnError = (e) => {
    e.target.src = profilePic;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(false);
  };

  const handleMenuItemClick = (actionType, data) => {
    setSelectedItem(actionType);
    switch (actionType) {
      case 'Deactivate':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Block':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Activate':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Unblock':
        props?.onClickStatusIcon(actionType);
        break;
      default:
        // Handle other menu item actions if needed
        break;
    }
    handleMenuClose();
  };
  const getConditionalMenuItems = () => {
    const status = details?.status || '';

    switch (status.toLowerCase()) {
      case 'active':
        return ['Deactivate', 'Block'];
      case 'inactive':
        return ['Activate', 'Block'];
      case 'blocked':
        return ['Unblock'];
      default:
        return [];
    }
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case 'blocked':
        return block;
      case 'block':
        return block;
      case 'edit':
        return editmore;
      case 'deactivate':
        return deactive;
      case 'delete':
        return deleteicon;
      case 'unblock':
        return block;
      case 'activate':
        return deactive;
      default:
        return editmore;
    }
  };
  return (
    <Grid item container className="profileVendor">
      <Grid item xs={12}>
        <Grid item container direction="row" justifyContent="space-between">
          <Grid item>
            <ButtonBase className="vendorPic">
              <img
                alt="complex"
                src={details?.avtar ? details.avtar?.url : profilePic}
                className="height100 width100 br100 backgroundWhite cursorDefault"
                onError={handleOnError}
              />
            </ButtonBase>
          </Grid>
          <Grid item>
            <Grid item xs={1}>
              {props?.type !== 'vehicle' &&
                details?.status?.toLowerCase() !== 'pending' && (
                  <Box>
                    {props?.statusChange &&
                    <IconButton size="large" onClick={(e) => handleMenuOpen(e)}>
                      <MoreVertIcon className="colorWhite" />
                    </IconButton>}

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      {getConditionalMenuItems().map((menuItem, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleMenuItemClick(menuItem)}
                        >
                          <span className="mr10 alignItem">
                            <img src={moreIconSrc(menuItem)} alt={menuItem} />
                          </span>
                          <Typography variant={'body2'} className="fw500">
                            {menuItem}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                )}
            </Grid>
          </Grid>
        </Grid>

        <Grid container direction="row" justifyContent='space-between' alignItems='center'>
            <Grid item>
            <Typography
              gutterBottom
              className=" font20 fw600 ml40 marginTop"
              variant="subtitle1"
              component="div"
            >
              {details?.companyName
                ? details?.companyName
                : details?.name
                ? details?.name
                : details?.complianceName
                ? details?.complianceName
                : details?.carModel
                ? details?.carModel
                : details?.firstName
                ? details?.firstName + ' ' + details?.lastName
                : 'Not Available'}
              {details?.rating && (
                <span className="fw400 font14 ml10">
                  <img
                    src={star}
                    alt="star"
                    className="width16 marginLeft16"
                  />
                  {' ' + details?.rating}
                </span>
              )}
            </Typography>
            </Grid>
            <Grid item className="mr10">
                {(details?.status || details?.isApproved) &&
                  (details?.status !== null ||
                    details?.isApproved !== null) && (
                    <Typography
                      className={`profileButton ${
                        details?.status
                          ? details?.status.toLowerCase() + 'Status'
                          : details?.isApproved.toLowerCase() + 'Status'
                      }`}
                    >
                      {details?.status
                        ? details?.status
                        : details?.isApproved
                        ? details?.isApproved
                        : 'Not Available'}
                    </Typography>
                  )}
              </Grid>
              </Grid>
      
        <Grid container direction="row" justifyContent='space-between' alignItems='center' className='mt15'>
          <Grid item >
            <Typography
              className="font14 fontNormal colorGrey ml40"
              variant="body2"
              gutterBottom
            >
              {(details?.city || details?.location) && (
                <>
                  <span>
                    <img src={location} alt="location" className="mr10" />
                  </span>
                  {details?.city
                    ? details?.city
                    : details?.location
                    ? details?.location
                    : details?.DemandProfile?.location
                    ? details?.DemandProfile?.location
                    : 'Not Available'}
                </>
              )}
              {details?.regNumber && details?.regNumber}
            </Typography>
          </Grid>
          <Grid item className="mr10">
                {details?.businessType === businessTypeData?.both &&
                    <Typography
                      className='colorPrimary flex'
                    >
                      <Typography className='mr10 font16'>Public</Typography>
                      <Typography className='font16'>Corporate</Typography>
                    </Typography>
                  }

                  {details?.businessType === businessTypeData?.coorporate &&
                    <Typography
                      className='colorPrimary flex'
                    >
                      <Typography className='font16'>Corporate</Typography>
                    </Typography>
                  }
                  {details?.businessType === businessTypeData?.public &&
                    <Typography
                      className='colorPrimary flex'
                    >
                      <Typography className='font16'>Public</Typography>
                    </Typography>
                  }
              </Grid>
        </Grid>
      </Grid>
      <CommonTableDialog />
    </Grid>
  );
}

export default DetailsCard;
